export default "__VITE_ASSET__D32bz6bJ__"